<div *ngIf="object.filename != null && object.file == null" (click)="showUploader()" class="document">
  <div>{{ filename }}</div>
  <div class="remove-file" (click)="remove();$event.stopPropagation()" title="Datei entfernen">
    <span class="iconify" data-icon="fa:times"></span>
  </div>
  <a [href]="object.filename" class="text-2xs font-bold hover:underline" (click)="$event.stopPropagation()">Download</a>
</div>

<div *ngIf="object.file != null" (click)="showUploader()" class="document changed">
  <div>{{ object.file.name }}</div>
  <div class="remove-file" (click)="remove();$event.stopPropagation()" title="Datei entfernen">
    <span class="iconify" data-icon="fa:times"></span>
  </div>
</div>

<div matRipple (click)="showUploader()" class="document" *ngIf="object.filename == null && object.file == null">
  <em>Datei wählen</em>
  <div class="remove-file" (click)="remove();$event.stopPropagation()" title="Datei entfernen">
    <span class="iconify" data-icon="fa:times"></span>
  </div>

</div>
<input class="hidden" #file type="file" (change)="previewDocument(file.files)" />
